<template>
  <v-dialog v-model="dialog" :max-width="options.width" @keydown.esc="cancel">
    <v-card>

      <v-card-title class="title grey lighten-2" primary-title>
        主要顧客登録
      </v-card-title>

      <v-card-text>

        <v-text-field
            v-model="name"
            counter="50"
            hint=""
            label="顧客名称"
        ></v-text-field>

        <v-text-field
            v-model="remark"
            counter="250"
            hint=""
            label="コメント"
        ></v-text-field>

      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions class="pt-0">
        <v-spacer></v-spacer>

        <v-btn color="primary" elevation="0" @click.native="onSaveClick">追加</v-btn>
        <v-btn color="normal" elevation="0" @click.native="cancel">キャンセル</v-btn>
      </v-card-actions>

    </v-card>
  </v-dialog>
</template>
<script>
import BaseDialog from "@/components/dialogs/BaseDialog";

export default {
  mixins:[BaseDialog],
  components: {},
  props: [],
  data() {
    return {
        name:"",
        remark:"",
    };
  },
  methods: {

    open(data,options) {

      this.name = data.name;
      this.remark = data.remark;

      this.options = Object.assign(this.options, options); // 使っていないけど一応

      this.dialog = true;
      return new Promise((resolve, reject) => {
        this.resolve = resolve;
        this.reject = reject;
      });
    },

    onSaveClick(){
      this.resolve({
        name:this.name,
        remark:this.remark,
      });
      this.dialog = false;
    },

  },

}
/*
// 呼び出し方法
// https://qiita.com/ta1nakamura/items/f844dd2437af8ecc5674
async onClickOpen(){
  console.log('--onClickOpen')
  if (await this.$refs.confirm.open('Delete', 'Are you sure?', { color: 'red' })) {
    console.log('--yes')
  }else{
    console.log('--no')
  }
}
* */
</script>
